// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4642) return "static/chunks/4642-86178d7faa4c304a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3303":"c6e581596dd386d2","7429":"9624733d9797d646"}[chunkId] + ".js";
};